// src/stone/icons/CloseRound.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var CloseRound = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20",
    width: "1em",
    height: "1em",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "currentcolor",
          fillOpacity: 0.877,
          fillRule: "evenodd",
          d: "M10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16m-7.071.929A10 10 0 1 1 17.07 17.07 10 10 0 0 1 2.93 2.93",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "currentcolor",
          fillOpacity: 0.877,
          d: "M7.707 6.293a1 1 0 0 0-1.414 1.414l2.296 2.296-2.29 2.29a1 1 0 1 0 1.414 1.414l2.29-2.29 2.287 2.287a1 1 0 0 0 1.414-1.414l-2.287-2.287 2.293-2.292a1 1 0 0 0-1.415-1.415L10.004 8.59z"
        }
      )
    ]
  }
);
var CloseRound_default = CloseRound;

export {
  CloseRound_default
};
